var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-f3" },
    [
      _c(
        "div",
        { staticClass: "f22 flex items-center fb wrap pad20-t pad15-b" },
        [
          _vm.detail && _vm.detail.orderDtlBo && _vm.detail.orderDtlBo.id
            ? _c("div", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.detail.orderDtlBo.orderType == 0
                        ? "普通订单"
                        : _vm.detail.orderDtlBo.orderType == 2
                        ? "集采订单"
                        : "普通订单"
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm.detail.firstOrderFlag
            ? _c(
                "div",
                {
                  staticClass:
                    "flex-shrink f14 mar10-l text-center radius10 white first-order-flag"
                },
                [_vm._v("新客首单")]
              )
            : _vm._e()
        ]
      ),
      _vm.loaded
        ? _c(
            "div",
            {
              staticClass: "gray3 wrap seller",
              staticStyle: { "min-height": "900px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex bg-white mar20-b state",
                  staticStyle: { "min-height": "200px" }
                },
                [
                  _c("div", { staticClass: "text-center left" }, [
                    _c("div", { staticClass: "pad25-t pad5-b" }, [
                      _vm._v("订单编号：" + _vm._s(_vm.detail.orderId))
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "flex items-center pad5-b justify-center",
                        attrs: {
                          target: "_blank",
                          href:
                            "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png"
                          }
                        }),
                        _c("div", { staticClass: "pad5-l" }, [
                          _vm._v("联系客服")
                        ]),
                        _vm.detail.orderDtlBo.orderType == 3 ||
                        _vm.detail.orderDtlBo.orderType == 4
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "behalfPurchaseOrder pad10-lr mar10-lr radius4"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.detail.orderDtlBo.orderType == 3
                                        ? "代采订单"
                                        : "预订单"
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "fb f26",
                        staticStyle: { color: "#71b247" }
                      },
                      [_vm._v(_vm._s(_vm.detail.orderStCn))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        staticStyle: { "margin-top": "15px" }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.editOrderSnapshotDialogVisible = true
                              }
                            }
                          },
                          [
                            _vm._v("\n            订单快照\n            "),
                            _c("i", { staticClass: "el-icon-arrow-right" })
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flex-auto",
                      style: {
                        paddingTop:
                          _vm.detail.orderDtlBo.orderType != 4 ? 0 : "78px"
                      }
                    },
                    [
                      _vm.detail.orderDtlBo.orderType != 4
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex f15 flex-item1 text-center mar25-t mar40-b"
                            },
                            [
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v("货品总额")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "¥ " +
                                      _vm._s(
                                        _vm.detail.omoney
                                          ? parseFloat(
                                              _vm.detail.omoney.toString()
                                            ).toFixed(2)
                                          : "0.00"
                                      )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v("合计优惠")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "¥ " +
                                      _vm._s(
                                        _vm.detail.smoney
                                          ? parseFloat(
                                              _vm.detail.smoney.toString()
                                            ).toFixed(2)
                                          : "0.00"
                                      )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v("实付金额")
                                ]),
                                _c("div", { staticClass: "blue" }, [
                                  _vm._v(
                                    "¥ " +
                                      _vm._s(
                                        _vm.detail.pmoney
                                          ? parseFloat(
                                              _vm.detail.pmoney.toString()
                                            ).toFixed(2)
                                          : "0.00"
                                      )
                                  )
                                ]),
                                _c("div", { staticClass: "blue" }, [
                                  _vm._v(
                                    "\n              （含运费\n              " +
                                      _vm._s(
                                        _vm.detail.freightMoney
                                          ? parseFloat(
                                              _vm.detail.freightMoney.toString()
                                            ).toFixed(2)
                                          : "0.00"
                                      ) +
                                      "\n              ）\n            "
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v("支付类型")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.detail.paymentTypeCn))
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v("支付状态")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.detail.paymentStCn))
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v("结算状态")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.detail.balanceStCn))
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pad30-b flex no-warp justify-center text-center pad20-lr btn-group"
                        },
                        _vm._l(_vm.buttonList, function(button) {
                          return _c(
                            "div",
                            { key: button.buttonCode },
                            [
                              button.explain === ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item mar12-l",
                                      on: {
                                        click: function($event) {
                                          return _vm.buttonSubmit(
                                            button,
                                            _vm.detail
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(button.buttonName) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "top",
                                        content: button.explain
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item mar12-l",
                                          on: {
                                            click: function($event) {
                                              return _vm.buttonSubmit(
                                                button,
                                                _vm.detail
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(button.buttonName))]
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm.detail.cancelType != 0
                        ? _c(
                            "div",
                            { staticClass: "pad20-b no-warp pad20-lr" },
                            [
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v(
                                    "取消操作人: " +
                                      _vm._s(
                                        _vm.detail.orderDtlBo.cancelOperatorName
                                      )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v(
                                    "取消时间: " + _vm._s(_vm.detail.cancleTime)
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb" }, [
                                  _vm._v(
                                    "取消原因: " +
                                      _vm._s(_vm.detail.orderDtlBo.cancelReason)
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.detail.orderTransportDtlBo &&
                      _vm.detail.orderTransportDtlBo.pickupTimeStartDate
                        ? _c("div", { staticClass: "flex justify-center" }, [
                            _c("div", { staticClass: "fb" }, [
                              _vm._v("提货期限：")
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.detail.orderTransportDtlBo
                                    .pickupTimeStartDate
                                ) +
                                  " - " +
                                  _vm._s(
                                    _vm.detail.orderTransportDtlBo
                                      .pickupTimeEndDate
                                  )
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _c(
                "el-tabs",
                {
                  staticClass: "bg-white pad20 tabs",
                  model: {
                    value: _vm.tabsActive,
                    callback: function($$v) {
                      _vm.tabsActive = $$v
                    },
                    expression: "tabsActive"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { "min-height": "600px" },
                      attrs: { label: "订单信息", name: "order1" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pad20 flex f14 flex-item1 mar20-b border"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              _c("div", { staticClass: "flex mar10-b" }, [
                                _c("div", { staticClass: "w92 gray6" }, [
                                  _vm._v("下单时间：")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.detail.orderTime))
                                ])
                              ]),
                              _c("div", { staticClass: "flex mar10-b" }, [
                                _c("div", { staticClass: "gray6 w92" }, [
                                  _vm._v("商品总价：")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "¥ " +
                                      _vm._s(
                                        _vm.thisOrderGoodsMoney
                                          ? parseFloat(
                                              _vm.thisOrderGoodsMoney.toString()
                                            ).toFixed(2)
                                          : "0.00"
                                      )
                                  )
                                ])
                              ]),
                              _vm.detail.orderDtlBo.orderType != 4
                                ? [
                                    _c("div", { staticClass: "flex mar10-b" }, [
                                      _c("div", { staticClass: "w92 gray6" }, [
                                        _vm._v("店铺券优惠：")
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "¥ " +
                                            _vm._s(
                                              _vm.detail.couponMoney
                                                ? parseFloat(
                                                    _vm.detail.couponMoney.toString()
                                                  ).toFixed(2)
                                                : "0.00"
                                            )
                                        )
                                      ])
                                    ]),
                                    _c("div", { staticClass: "flex mar10-b" }, [
                                      _c("div", { staticClass: "w92 gray6" }, [
                                        _vm._v("价格优惠：")
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "¥ " +
                                            _vm._s(
                                              _vm.detail.smoney
                                                ? parseFloat(
                                                    _vm.detail.smoney.toString()
                                                  ).toFixed(2)
                                                : "0.00"
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm.detail.zkRecord.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6 w100" },
                                              [_vm._v("奖励金抵扣：")]
                                            ),
                                            _vm._l(
                                              _vm.detail.zkRecord,
                                              function(zk) {
                                                return _c(
                                                  "div",
                                                  { key: zk.payTool },
                                                  [
                                                    zk.payTool == "BOUNTY_MONEY"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            "¥ " +
                                                              _vm._s(
                                                                zk.amount
                                                                  ? parseFloat(
                                                                      zk.amount.toString()
                                                                    ).toFixed(2)
                                                                  : "0.00"
                                                              )
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm.detail.orderDtlBo.orderType == 4
                                ? [
                                    _c("div", { staticClass: "flex mar10-b" }, [
                                      _c("div", { staticClass: "w92 gray6" }, [
                                        _vm._v("支付定金：")
                                      ]),
                                      _c("div", [
                                        _vm._v("¥ " + _vm._s(_vm.detail.pmoney))
                                      ])
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              _c("div", { staticClass: "flex mar10-b" }, [
                                _c("div", { staticClass: "w92 gray6" }, [
                                  _vm._v("支付时间：")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.detail.paymentTime))
                                ])
                              ]),
                              _c("div", { staticClass: "flex mar10-b" }, [
                                _c("div", { staticClass: "gray6 w100" }, [
                                  _vm._v("商品总数：")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.thisOrderGoodsNum))
                                ])
                              ]),
                              _vm.detail.orderDtlBo.orderType != 4
                                ? [
                                    _vm.detail.zkRecord.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6 w100" },
                                              [_vm._v("店铺积分优惠：")]
                                            ),
                                            _vm._l(
                                              _vm.detail.zkRecord,
                                              function(zk) {
                                                return _c(
                                                  "div",
                                                  { key: zk.payTool },
                                                  [
                                                    zk.payTool == "SC_POINTS"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            "¥ " +
                                                              _vm._s(
                                                                zk.amount
                                                                  ? parseFloat(
                                                                      zk.amount.toString()
                                                                    ).toFixed(2)
                                                                  : "0.00"
                                                              )
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6 w100" },
                                              [_vm._v("店铺积分优惠：")]
                                            ),
                                            _c("div", [_vm._v("¥ 0.00")])
                                          ]
                                        ),
                                    _c("div", { staticClass: "flex" }, [
                                      _c("div", { staticClass: "gray6 w100" }, [
                                        _vm._v("运费：")
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "¥ " +
                                            _vm._s(
                                              _vm.detail.freightMoney
                                                ? parseFloat(
                                                    _vm.detail.freightMoney.toString()
                                                  ).toFixed(2)
                                                : "0.00"
                                            )
                                        )
                                      ])
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              _c("div", { staticClass: "flex mar10-b" }, [
                                _c("div", { staticClass: "gray6 w100" }, [
                                  _vm._v("结算时间：")
                                ]),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.detail.balanceTime))
                                ])
                              ]),
                              _vm.detail.orderDtlBo.orderType != 4
                                ? [
                                    _c("div", { staticClass: "flex mar10-b" }, [
                                      _c("div", { staticClass: "gray6" }, [
                                        _vm._v(" ")
                                      ])
                                    ]),
                                    _c("div", { staticClass: "flex mar10-b" }, [
                                      _c("div", { staticClass: "gray6 w92" }, [
                                        _vm._v("平台券优惠：")
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "¥ " +
                                            _vm._s(
                                              _vm.detail.platformMoney
                                                ? parseFloat(
                                                    _vm.detail.platformMoney.toString()
                                                  ).toFixed(2)
                                                : "0.00"
                                            )
                                        )
                                      ])
                                    ]),
                                    _c("div", { staticClass: "flex" }, [
                                      _c("div", { staticClass: "gray6" }, [
                                        _vm._v("新用户首单运费优惠：")
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "¥ " +
                                            _vm._s(
                                              _vm.detail
                                                .freightPromotionAmount ||
                                                "0.00"
                                            )
                                        )
                                      ])
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm.detail.orderDtlBo.orderType != 4
                            ? _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "flex mar10-b" }, [
                                  _c("div", { staticClass: "gray6" }, [
                                    _vm._v(" ")
                                  ])
                                ]),
                                _c("div", { staticClass: "flex mar10-b" }, [
                                  _c("div", { staticClass: "gray6" }, [
                                    _vm._v(" ")
                                  ])
                                ]),
                                _c("div", { staticClass: "flex mar10-b" }, [
                                  _c("div", { staticClass: "gray6" }, [
                                    _vm._v("平台现金券优惠：")
                                  ]),
                                  _c("div", { staticClass: "mar10-l" }, [
                                    _vm._v(
                                      "¥ " +
                                        _vm._s(
                                          _vm.detail.cashMoney > 0
                                            ? parseFloat(
                                                _vm.detail.cashMoney.toString()
                                              ).toFixed(2)
                                            : "0.00"
                                        )
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "gray6 w92" }, [
                                    _vm._v("返还金额：")
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "¥ " +
                                        _vm._s(
                                          _vm.detail.differenceMoney
                                            ? parseFloat(
                                                _vm.detail.differenceMoney.toString()
                                              ).toFixed(2)
                                            : "0.00"
                                        )
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm.detail.relationOrderId
                        ? _c(
                            "div",
                            { staticClass: "pad20 flex mar20-b border" },
                            [
                              _vm.detail.electronicSend &&
                              _vm.detail.electronicSend[0]
                                ? _c(
                                    "div",
                                    { staticClass: "flex mar10-tb mar40-r" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "nowrap pad10-r" },
                                        [_vm._v("发货单：")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-auto flex flex-wrap"
                                        },
                                        _vm._l(
                                          _vm.detail.electronicSend,
                                          function(item) {
                                            return _c(
                                              "div",
                                              {
                                                key: item.contractSignNum,
                                                staticClass: "blue pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.contractPreviewHandle(
                                                      item.contractSignNum
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      item.contractSignNum
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.detail.electronicReceipt &&
                              _vm.detail.electronicReceipt[0]
                                ? _c(
                                    "div",
                                    { staticClass: "flex mar10-tb mar40-r" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "nowrap pad10-r" },
                                        [_vm._v("收货单：")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-auto flex flex-wrap"
                                        },
                                        _vm._l(
                                          _vm.detail.electronicReceipt,
                                          function(item) {
                                            return _c(
                                              "div",
                                              {
                                                key: item.contractSignNum,
                                                staticClass: "blue pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.contractPreviewHandle(
                                                      item.contractSignNum
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      item.contractSignNum
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "mar10-tb mar40-r" }, [
                                _vm._v("\n            预订单："),
                                _c(
                                  "a",
                                  {
                                    staticClass: "blue pointer",
                                    attrs: {
                                      href:
                                        "/v/order/detailSeller/" +
                                        _vm.detail.relationOrderId,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.detail.relationOrderId))]
                                )
                              ]),
                              _c("div", { staticClass: "mar10-tb mar40-r" }, [
                                _vm._v(
                                  "发货差额：" +
                                    _vm._s(_vm.detail.fhCeAmount || 0)
                                )
                              ]),
                              _c("div", { staticClass: "mar10-tb mar40-r" }, [
                                _vm._v(
                                  "质量扣补：" + _vm._s(_vm.detail.kbAmount)
                                )
                              ]),
                              _c("div", { staticClass: "mar10-tb" }, [
                                _vm._v(
                                  "合计：" + _vm._s(_vm.detail.totalKbAmount)
                                )
                              ])
                            ]
                          )
                        : [
                            (_vm.detail.electronicReceipt &&
                              _vm.detail.electronicReceipt.length) ||
                            (_vm.detail.electronicSend &&
                              _vm.detail.electronicSend.length) ||
                            _vm.detail.noticeOrderContractSignNum
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pad20 flex flex-item1 mar20-b border"
                                  },
                                  [
                                    _vm.detail.electronicSend &&
                                    _vm.detail.electronicSend[0]
                                      ? _c(
                                          "div",
                                          { staticClass: "flex mar10-tb" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "nowrap pad10-r" },
                                              [_vm._v("发货单：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-auto flex flex-wrap"
                                              },
                                              _vm._l(
                                                _vm.detail.electronicSend,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.contractSignNum,
                                                      staticClass:
                                                        "pad20-r blue pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.contractPreviewHandle(
                                                            item.contractSignNum
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            item.contractSignNum
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.detail.electronicReceipt &&
                                    _vm.detail.electronicReceipt[0]
                                      ? _c(
                                          "div",
                                          { staticClass: "flex mar10-tb" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "nowrap pad10-r" },
                                              [_vm._v("收货单：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-auto flex flex-wrap"
                                              },
                                              _vm._l(
                                                _vm.detail.electronicReceipt,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.contractSignNum,
                                                      staticClass:
                                                        "pad20-r blue pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.contractPreviewHandle(
                                                            item.contractSignNum
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            item.contractSignNum
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.detail.noticeOrderContractSignNum
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex mar10-tb mar40-r"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "nowrap pad10-r" },
                                              [_vm._v("电子提货通知单：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-auto flex flex-wrap"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "blue pointer",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.contractPreviewHandle(
                                                          _vm.detail
                                                            .noticeOrderContractSignNum
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.detail
                                                            .noticeOrderContractSignNum
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ],
                      _vm.detail.orderDtlBo.orderType == 4 &&
                      _vm.showPreOrderInboundInfo
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "pad20 flex flex-item1 mar20-b border"
                            },
                            [
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb f15 mar15-b" }, [
                                  _vm._v("入库通知信息")
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w92 mar10-b gray6" },
                                    [_vm._v("时间：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.noticeOperationRecord
                                            ? _vm.noticeOperationRecord
                                                .operatorContent
                                            : "-"
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w92 mar10-b gray6" },
                                    [_vm._v("操作人：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.noticeOperationRecord
                                            ? _vm.noticeOperationRecord.boIdName
                                            : "-"
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _c(
                                "div",
                                { staticClass: "item border-l pad20-l" },
                                [
                                  _c("div", { staticClass: "fb f15 mar15-b" }, [
                                    _vm._v("入库验收信息")
                                  ]),
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w92 mar10-b gray6" },
                                      [_vm._v("时间：")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex-auto mar10-b" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.acceptanceOperationRecord
                                              ? _vm.acceptanceOperationRecord
                                                  .operatorContent
                                              : "-"
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w92 mar10-b gray6" },
                                      [_vm._v("操作人：")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex-auto mar10-b" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.acceptanceOperationRecord
                                              ? _vm.acceptanceOperationRecord
                                                  .boIdName
                                              : "-"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "item border-l pad20-l" },
                                [
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w130 mar10-b gray6" },
                                      [_vm._v("入库通知验收单：")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex-auto mar10-b" },
                                      [
                                        _vm.detail.yddNoticeOrderContractSignNum
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "blue pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.contractPreviewHandle(
                                                      _vm.detail
                                                        .yddNoticeOrderContractSignNum
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  查看\n                "
                                                )
                                              ]
                                            )
                                          : _c("div", [_vm._v("-")])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.detail.orderDtlBo.orderType == 4
                        ? _c("div", { staticClass: "pad20 mar20-b border" }, [
                            _c("div", { staticClass: "fb f15 mar15-b" }, [
                              _vm._v("付款信息")
                            ]),
                            _c("div", { staticClass: "flex flex-item1" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("付款人：" + _vm._s(_vm.detail.boIdName))
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _vm._v("电话：" + _vm._s(_vm.detail.boIdPhone))
                              ]),
                              _vm.detail.orgName != ""
                                ? _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "所属企业：" + _vm._s(_vm.detail.orgName)
                                    )
                                  ])
                                : _vm._e(),
                              _vm.detail.substitutionName != ""
                                ? _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "业务员：" +
                                        _vm._s(_vm.detail.substitutionName)
                                    )
                                  ])
                                : _vm._e(),
                              _vm.detail.customerName != ""
                                ? _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "客户：" + _vm._s(_vm.detail.customerName)
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _c(
                            "div",
                            {
                              staticClass:
                                "pad20 flex flex-item1 mar20-b border"
                            },
                            [
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "fb f15 mar15-b" }, [
                                  _vm._v("付款信息")
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w92 mar10-b gray6" },
                                    [_vm._v("付款人：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [_vm._v(_vm._s(_vm.detail.boIdName))]
                                  )
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w92 mar10-b gray6" },
                                    [_vm._v("电话：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [_vm._v(_vm._s(_vm.detail.boIdPhone))]
                                  )
                                ]),
                                _vm.detail.orgName != ""
                                  ? _c("div", { staticClass: "flex" }, [
                                      _c(
                                        "div",
                                        { staticClass: "w92 mar10-b gray6" },
                                        [_vm._v("所属企业：")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex-auto mar10-b" },
                                        [_vm._v(_vm._s(_vm.detail.orgName))]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.detail.substitutionName != ""
                                  ? _c("div", { staticClass: "flex" }, [
                                      _c(
                                        "div",
                                        { staticClass: "w92 mar10-b gray6" },
                                        [_vm._v("业务员：")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex-auto mar10-b" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.detail.substitutionName)
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.detail.customerName != ""
                                  ? _c("div", { staticClass: "flex" }, [
                                      _c(
                                        "div",
                                        { staticClass: "w92 mar10-b gray6" },
                                        [_vm._v("客户：")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex-auto mar10-b" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.detail.customerName)
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm.detail.delivery == "1"
                                ? _c(
                                    "div",
                                    { staticClass: "item border-l pad20-l" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "fb f15 mar15-b" },
                                        [_vm._v("收货人信息")]
                                      ),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w80 mar10-b gray6" },
                                          [_vm._v("收货人：")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderTransportDtlBo
                                                  .linkman
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w80 mar10-b gray6" },
                                          [_vm._v("电话：")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderTransportDtlBo
                                                  .tel
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w80 mar10-b gray6" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.delivery == "2"
                                                  ? "自提地址"
                                                  : "收货地址"
                                              ) + "："
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderTransportDtlBo
                                                  .addr
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm.detail.delivery == "2"
                                ? _c(
                                    "div",
                                    { staticClass: "item border-l pad20-l" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "fb f15 mar15-b" },
                                        [_vm._v("提货人信息")]
                                      ),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w80 mar10-b gray6" },
                                          [_vm._v("提货人：")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderTransportDtlBo
                                                  .linkman
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w80 mar10-b no-warp gray6"
                                          },
                                          [_vm._v("电话：")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderTransportDtlBo
                                                  .tel
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w80 mar10-b gray6" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.delivery == "2"
                                                  ? "自提地址"
                                                  : "收货地址"
                                              ) + "："
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderTransportDtlBo
                                                  .addr
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "item border-l pad20-l" },
                                [
                                  _c("div", { staticClass: "fb f15 mar15-b" }, [
                                    _vm._v("配送信息")
                                  ]),
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w130 mar10-b gray6" },
                                      [_vm._v("配送方式：")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex-auto mar10-b" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detail.delivery == "2"
                                              ? "买家自提"
                                              : "卖家配送"
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm.detail.receiveTime
                                    ? _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w130 mar10-b gray6" },
                                          [_vm._v("确认收货时间")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detail.receiveTime)
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.detail.delivery == "2"
                                    ? _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w130 mar10-b gray6" },
                                          [_vm._v("自提时间：")]
                                        ),
                                        !_vm.detail.orderTransportDtlBo
                                          .selfPickupTimeType
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "flex-auto mar10-b"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.detail
                                                        .orderTransportDtlBo
                                                        .pickupTime
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.detail.orderTransportDtlBo
                                          .selfPickupTimeType
                                          ? _c("div", [
                                              !_vm.detail.orderTransportDtlBo
                                                .sellerConfirmPickupTimeStr
                                                ? _c(
                                                    "div",
                                                    [
                                                      _vm.detail.orderStatus !=
                                                        4 &&
                                                      _vm.detail.orderStatus !=
                                                        5 &&
                                                      _vm.detail.orderStatus !=
                                                        6
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "primary",
                                                                size: "mini"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showConfirmPickup(
                                                                    0,
                                                                    0
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    确认提货时间\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.detail
                                                              .orderTransportDtlBo
                                                              .sellerConfirmPickupTimeStr
                                                          ) +
                                                          "\n                  " +
                                                          _vm._s(
                                                            _vm.detail
                                                              .orderTransportDtlBo
                                                              .sellerConfirmPickupPeriod
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                      _vm.detail.orderStatus !=
                                                        4 &&
                                                      _vm.detail.orderStatus !=
                                                        5 &&
                                                      _vm.detail.orderStatus !=
                                                        6
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "primary",
                                                                size: "mini"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showConfirmPickup(
                                                                    1,
                                                                    0
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    修改提货时间\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w130 mar10-b gray6" },
                                          [_vm._v("预计发货时间：")]
                                        ),
                                        _c(
                                          "div",
                                          [
                                            _vm.detail.orderTransportDtlBo
                                              .sellerConfirmPickupTimeStr
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.detail
                                                        .orderTransportDtlBo
                                                        .sellerConfirmPickupTimeStr
                                                    )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm.detail.orderStatus != 3 &&
                                            _vm.detail.orderStatus != 4 &&
                                            _vm.detail.orderStatus != 5 &&
                                            _vm.detail.orderStatus != 6
                                              ? [
                                                  _vm.detail.orderTransportDtlBo
                                                    .sellerConfirmPickupTimeStr
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            size: "small"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.showConfirmPickup(
                                                                1,
                                                                1
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    修改预计发货时间\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            size: "small"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.showConfirmPickup(
                                                                0,
                                                                1
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "确认预计发货时间"
                                                          )
                                                        ]
                                                      )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]),
                                  _vm.detail.delivery == "2" &&
                                  _vm.detail.orderDtlBo.orderVehicleStatus == 1
                                    ? _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w130 mar10-b gray6" },
                                          [_vm._v("卖家确认自提时间：")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-auto mar10-b" },
                                          [_vm._v(_vm._s(_vm.detail.sendTime))]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.detail.delivery == "2"
                                    ? _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "w130 mar10-b gray6" },
                                          [_vm._v("自提车辆：")]
                                        ),
                                        _vm.detail.orderDtlBo &&
                                        _vm.detail.orderDtlBo
                                          .orderBuyerVehicleList
                                          ? _c(
                                              "div",
                                              { staticClass: "flex-auto" },
                                              [
                                                _vm.detail.orderDtlBo
                                                  .orderBuyerVehicleList.length
                                                  ? [
                                                      _vm.detail.orderDtlBo
                                                        .orderBuyerVehicleList
                                                        .length == 1 ||
                                                      !_vm.vehicleListCollapse
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mar10-b"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.detail
                                                                      .orderDtlBo
                                                                      .orderBuyerVehicleList[0]
                                                                      .licensePlateNum
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.detail
                                                                      .orderDtlBo
                                                                      .orderBuyerVehicleList[0]
                                                                      .name
                                                                  ) +
                                                                  "\n                    " +
                                                                  _vm._s(
                                                                    _vm.detail
                                                                      .orderDtlBo
                                                                      .orderBuyerVehicleList[0]
                                                                      .tel
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._l(
                                                            _vm.detail
                                                              .orderDtlBo
                                                              .orderBuyerVehicleList,
                                                            function(vehicle) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    vehicle.id,
                                                                  staticClass:
                                                                    "mar10-b"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        vehicle.licensePlateNum
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        vehicle.name
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        vehicle.tel
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                      _vm.detail.orderDtlBo
                                                        .orderBuyerVehicleList
                                                        .length > 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pad5-tb text-center blue pointer",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.vehicleListCollapse = !_vm.vehicleListCollapse
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm.vehicleListCollapse
                                                                ? [
                                                                    _vm._v(
                                                                      "收起"
                                                                    )
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      "展开"
                                                                    )
                                                                  ]
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : _vm._e(),
                                                _vm.detail.orderDtlBo
                                                  .orderBuyerVehicleList
                                                  .length == 0
                                                  ? [
                                                      _vm.detail.orderDtlBo
                                                        .orderSellVehicleList
                                                        .length == 1 &&
                                                      !_vm.vehicleListCollapse
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mar10-b"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.detail
                                                                      .orderDtlBo
                                                                      .orderSellVehicleList[0]
                                                                      .licensePlateNum
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.detail
                                                                      .orderDtlBo
                                                                      .orderSellVehicleList[0]
                                                                      .name
                                                                  ) +
                                                                  "\n                    " +
                                                                  _vm._s(
                                                                    _vm.detail
                                                                      .orderDtlBo
                                                                      .orderSellVehicleList[0]
                                                                      .tel
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._l(
                                                            _vm.detail
                                                              .orderDtlBo
                                                              .orderSellVehicleList,
                                                            function(vehicle) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    vehicle.id,
                                                                  staticClass:
                                                                    "mar10-b"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        vehicle.licensePlateNum
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        vehicle.name
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        vehicle.tel
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                      _vm.detail.orderDtlBo
                                                        .orderSellVehicleList
                                                        .length > 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pad5-tb text-center blue pointer",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.vehicleListCollapse = !_vm.vehicleListCollapse
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm.vehicleListCollapse
                                                                ? [
                                                                    _vm._v(
                                                                      "收起"
                                                                    )
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      "展开"
                                                                    )
                                                                  ]
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                      _vm.detail.paymentRecordBoList &&
                      _vm.detail.paymentRecordBoList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "pad20 mar20-b pay" },
                            [
                              _c("div", { staticClass: "flex" }, [
                                _c("div", { staticClass: "gray3 f16 fb" }, [
                                  _vm._v("支付信息")
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "flex-auto text-right" },
                                  [
                                    _vm._v("\n              已支付"),
                                    _c("span", { staticClass: "pad5-lr red" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.detail.paymentRecordBoList
                                            ? _vm.detail.paymentRecordBoList
                                                .length
                                            : 0
                                        )
                                      )
                                    ]),
                                    _vm._v("笔，共计"),
                                    _c("span", { staticClass: "pad5-lr red" }, [
                                      _vm._v(
                                        "¥ " +
                                          _vm._s(
                                            parseFloat(
                                              _vm.detail.pmoney.toString()
                                            ).toFixed(2)
                                          )
                                      )
                                    ]),
                                    _vm.detail.orderDtlBo.orderType != 4
                                      ? [
                                          _vm._v(
                                            "\n                ，剩余待支付金额"
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "pad5-lr red" },
                                            [
                                              _vm._v(
                                                "¥ " +
                                                  _vm._s(
                                                    (
                                                      _vm.detail.fmoney -
                                                      _vm.detail.pmoney
                                                    ).toFixed(2)
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]),
                              _vm._l(_vm.detail.paymentRecordBoList, function(
                                payment
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: payment.paymentTime,
                                    staticClass: "flex mar20-t"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "gray6 pad20-r" },
                                      [_vm._v(_vm._s(payment.paymentTime))]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        "¥ " +
                                          _vm._s(
                                            parseFloat(
                                              payment.pmoney.toString()
                                            ).toFixed(2)
                                          )
                                      )
                                    ])
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _c("logistics_dtl", {
                        attrs: {
                          orderDelivery: _vm.orderDelivery,
                          goodsPic: _vm.orderGoodsList[0].goodsPic
                        }
                      }),
                      _vm.detail.buyerCfyVoucherPicList.length > 0
                        ? _c("div", { staticClass: "bg-white mar20-b f15" }, [
                            _c("div", { staticClass: "pad20 border" }, [
                              _c("div", { staticClass: "mar15-b fb" }, [
                                _vm._v("处方药凭证")
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mar15-t flex flex-wrap upload"
                                  },
                                  _vm._l(
                                    _vm.detail.buyerCfyVoucherPicList,
                                    function(cfyVoucher) {
                                      return _c(
                                        "div",
                                        {
                                          key: cfyVoucher.id,
                                          staticClass: "mar10-r relative box"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                cfyVoucher.url +
                                                "?imageView2/1/w/80/h/80"
                                            }
                                          })
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "bg-white" }, [
                        _c("div", { staticClass: "pad20 border" }, [
                          _c("div", { staticClass: "fb f15" }, [
                            _vm._v("订单备注")
                          ]),
                          _c("div", { staticClass: "mar15-t" }, [
                            _c("span", { staticClass: "fb" }, [
                              _vm._v("买家备注：")
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm.detail.memo == "" ? "无" : _vm.detail.memo
                              )
                            )
                          ]),
                          _c("div", { staticClass: "fb mar15-t mar10-b" }, [
                            _vm._v("卖家备注：")
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("el-input", {
                                attrs: {
                                  rows: "4",
                                  maxlength: "1000",
                                  type: "textarea"
                                },
                                model: {
                                  value: _vm.memoSeller,
                                  callback: function($$v) {
                                    _vm.memoSeller =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "memoSeller"
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "mar10-lr self-center w80" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.memoSellerSubmit }
                                        },
                                        [_vm._v("提交")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    2
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { "min-height": "600px" },
                      attrs: { label: "商品信息", name: "order2" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-item1 goods-list" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.orderGoodsList,
                                "header-row-class-name": "gray3 tab-header",
                                border: "",
                                "cell-class-name": "cell-td"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "货品", width: "500px" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex pad15-lr pad15-b",
                                              class: {
                                                "mar15-b": scope.$index,
                                                "border-b":
                                                  scope.row.orderGoodsGiftBo
                                                    .length > 0
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "overflow flex-shrink mar12-r wh72"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        scope.row.goodsPic +
                                                        "?imageView2/1/w/72/h/72"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex-auto flex flex-column justify-between"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "gray3 lh20"
                                                    },
                                                    [
                                                      scope.row
                                                        .optimizationCard == 1
                                                        ? _c(
                                                            "el-tag",
                                                            {
                                                              staticClass:
                                                                "mar5-r",
                                                              attrs: {
                                                                type: "danger",
                                                                size: "mini"
                                                              }
                                                            },
                                                            [_vm._v("优选")]
                                                          )
                                                        : _vm._e(),
                                                      scope.row.cfyCard == 1
                                                        ? _c(
                                                            "el-tag",
                                                            {
                                                              staticClass:
                                                                "mar5-r",
                                                              attrs: {
                                                                type: "danger",
                                                                size: "mini"
                                                              }
                                                            },
                                                            [_vm._v("处方药")]
                                                          )
                                                        : _vm._e(),
                                                      scope.row.preventCard == 1
                                                        ? _c(
                                                            "el-tag",
                                                            {
                                                              staticClass:
                                                                "mar5-r",
                                                              attrs: {
                                                                type: "danger",
                                                                size: "mini"
                                                              }
                                                            },
                                                            [_vm._v("防非")]
                                                          )
                                                        : _vm._e(),
                                                      scope.row.goodsTagList &&
                                                      scope.row.goodsTagList
                                                        .length
                                                        ? _vm._l(
                                                            scope.row
                                                              .goodsTagList,
                                                            function(tag) {
                                                              return _c(
                                                                "el-tag",
                                                                {
                                                                  key: tag,
                                                                  staticClass:
                                                                    "mar5-r",
                                                                  attrs: {
                                                                    type:
                                                                      "danger",
                                                                    size: "mini"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(tag)
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            scope.row.goodsName
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "gray9 mar4-t"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.goodsSpec
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          scope.row.orderGoodsGiftBo.length > 0
                                            ? _c(
                                                "div",
                                                _vm._l(
                                                  scope.row.orderGoodsGiftBo,
                                                  function(gift, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: gift.id,
                                                        staticClass:
                                                          "flex pad15-lr pad15-tb",
                                                        class: {
                                                          "border-t": index
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "overflow flex-shrink mar12-r wh72"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src:
                                                                  gift.giftGoodsPicUrl +
                                                                  "?imageView2/1/w/72/h/72"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex-auto"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "gray3 lh20"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    gift.giftGoodsName
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "gray9 mar4-t"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    gift.giftGoodsSpec
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  417279071
                                )
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "价格" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.sellPrice
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "f12 price-line"
                                                },
                                                [
                                                  _vm._v(
                                                    "¥ " +
                                                      _vm._s(
                                                        scope.row.sellPrice
                                                      )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "gray3 mar30-t",
                                              class: {
                                                "line-after":
                                                  scope.row.orderGoodsGiftBo &&
                                                  scope.row.orderGoodsGiftBo
                                                    .length
                                              },
                                              staticStyle: { height: "58px" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  ¥ " +
                                                  _vm._s(
                                                    scope.row.sellFactPrice
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          scope.row.orderGoodsGiftBo.length > 0
                                            ? _vm._l(
                                                scope.row.orderGoodsGiftBo,
                                                function(gift, index) {
                                                  return _c("div", {
                                                    key: gift.id,
                                                    staticClass: "h103",
                                                    class: {
                                                      "line-after":
                                                        index !=
                                                        scope.row
                                                          .orderGoodsGiftBo
                                                          .length -
                                                          1
                                                    }
                                                  })
                                                }
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3922113857
                                )
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "数量" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "gray3 mar30-t",
                                              class: {
                                                "line-after":
                                                  scope.row.orderGoodsGiftBo &&
                                                  scope.row.orderGoodsGiftBo
                                                    .length
                                              },
                                              staticStyle: { height: "58px" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  x " +
                                                  _vm._s(
                                                    scope.row.goodsQuantity
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          scope.row.orderGoodsGiftBo.length > 0
                                            ? _c(
                                                "div",
                                                _vm._l(
                                                  scope.row.orderGoodsGiftBo,
                                                  function(gift, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: gift.id,
                                                        staticClass:
                                                          "flex justify-center items-center flex-column h103",
                                                        class: {
                                                          "line-after":
                                                            index !=
                                                            scope.row
                                                              .orderGoodsGiftBo
                                                              .length -
                                                              1
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray3"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "¥ " +
                                                                _vm._s(
                                                                  gift.giftQuantity
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex justify-center"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "gift"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    gift.promotionDtlId &&
                                                                      gift.promotionDtlId !=
                                                                        "0"
                                                                      ? "赠品"
                                                                      : "套餐"
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  542018181
                                )
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "实际收货数量"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.orderRefundGoodsBo
                                            .goodsQuantityAccum >= 0
                                            ? _c(
                                                "div",
                                                { staticClass: "gray3" },
                                                [
                                                  _vm._v(
                                                    "\n                  x " +
                                                      _vm._s(
                                                        (
                                                          Math.round(
                                                            (scope.row
                                                              .goodsQuantity -
                                                              scope.row
                                                                .orderRefundGoodsBo
                                                                .goodsQuantityAccum) *
                                                              100 +
                                                              Number.EPSILON
                                                          ) / 100
                                                        ).toFixed(2)
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  605879959
                                )
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "e",
                                  align: "center",
                                  label: "金额"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "fb gray3 pad30-t justify-center flex"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pad2-r" },
                                                [_vm._v("¥")]
                                              ),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    (
                                                      Math.round(
                                                        scope.row
                                                          .goodsQuantity *
                                                          scope.row
                                                            .sellFactPrice *
                                                          100 +
                                                          Number.EPSILON
                                                      ) / 100
                                                    ).toFixed(2)
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1989323333
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.orderGoodsGiftBoList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "flex flex-item1 mar20-t" },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.orderGoodsGiftBoList,
                                    "header-row-class-name": "gray3 tab-header",
                                    border: "",
                                    "cell-class-name": "cell-td"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "",
                                      align: "",
                                      label: "赠品"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "flex" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "overflow flex-shrink mar12-r wh72"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            scope.row
                                                              .giftGoodsPicUrl +
                                                            "?imageView2/1/w/72/h/72"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-column justify-between"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "gray3 lh20"
                                                        },
                                                        [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              staticClass:
                                                                "mar5-r",
                                                              attrs: {
                                                                type: "danger",
                                                                size: "mini"
                                                              }
                                                            },
                                                            [_vm._v("赠品")]
                                                          ),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                scope.row
                                                                  .giftGoodsName
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2238843022
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "giftQuantity",
                                      align: "center",
                                      label: "数量"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              scope.row.giftQuantity > 0
                                                ? _c(
                                                    "div",
                                                    { staticClass: "gray3" },
                                                    [
                                                      _vm._v(
                                                        "x " +
                                                          _vm._s(
                                                            scope.row
                                                              .giftQuantity
                                                          )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1484091659
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { "min-height": "600px" },
                      attrs: { label: "订单凭证", name: "order3" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pad20 flex flex-item1 flex-item1 border certificate"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-column item" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center mar15-b" },
                                [
                                  _c("div", { staticClass: "f15 fb" }, [
                                    _vm._v("卖家凭证")
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "gray9 f12 mar10-l flex-auto"
                                    },
                                    [_vm._v("最多上传30张")]
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "pad10-b" }, [
                                _vm._v(
                                  "选择图片后需点击【确认上传】按钮完成凭证上传"
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "flex flex-wrap upload" },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex justify-center relative pointer box"
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              limit:
                                                30 -
                                                _vm.detail.sellerVoucherPicList
                                                  .length,
                                              action:
                                                _vm.env.VUE_APP_fileserver +
                                                "persistentUpload",
                                              "file-list":
                                                _vm.sellerVoucherPicList,
                                              "list-type": "picture-card",
                                              "on-success":
                                                _vm.uploadVoucherSuccess,
                                              "before-upload": _vm.uploadBefore,
                                              "on-remove":
                                                _vm.uploadVoucherRemove,
                                              "on-exceed":
                                                _vm.uploadVoucherExceed
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("./images/add.png")
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text-right pad15-r" },
                                      [_vm._v("上传文件")]
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mar10-l",
                                      on: { click: _vm.imgTransfer }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-center relative pointer box"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-upload el-upload--picture-card"
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("./images/add.png")
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-center",
                                          class: {
                                            "pad10-t":
                                              _vm.sellerVoucherPicList &&
                                              _vm.sellerVoucherPicList.length
                                          }
                                        },
                                        [_vm._v("手机传图")]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.detail.delivery == "1"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "flex mar40-t items-center"
                                    },
                                    [
                                      _c("div", [_vm._v("提货单号：")]),
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          placeholder: "请输入提货单号",
                                          type: "text"
                                        },
                                        model: {
                                          value: _vm.detail.takeGoodsNum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detail,
                                              "takeGoodsNum",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "detail.takeGoodsNum"
                                        }
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "mar10-l",
                                          attrs: { type: "primary" },
                                          on: { click: _vm.submitSellerVoucher }
                                        },
                                        [_vm._v("确认上传")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.detail.delivery == "2"
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex mar40-t items-center"
                                      },
                                      [
                                        _c("div", [_vm._v("提货单号：")]),
                                        _c("el-input", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            placeholder: "请输入提货单号",
                                            type: "text"
                                          },
                                          model: {
                                            value: _vm.detail.takeGoodsNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.detail,
                                                "takeGoodsNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "detail.takeGoodsNum"
                                          }
                                        }),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "mar10-l",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: _vm.submitSellerVoucher
                                            }
                                          },
                                          [_vm._v("确认上传")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              _c("div", { staticClass: "flex-auto" })
                            ],
                            2
                          ),
                          _c("div", { staticClass: "border-l pad20-l item" }, [
                            _c("div", { staticClass: "f15 fb mar15-b" }, [
                              _vm._v("订单凭证")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "relative certificate",
                                staticStyle: {
                                  "max-height": "500px",
                                  "overflow-y": "auto"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "line",
                                  staticStyle: { bottom: "84px" }
                                }),
                                _vm._l(_vm.detail.voucherPicMapList, function(
                                  voucherMap
                                ) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center mar5-r"
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "radius20 z-index2 ball"
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "mar10-l" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    voucherMap.voucherType ==
                                                      "SELLER"
                                                      ? "卖家"
                                                      : "买家"
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      voucherMap.boIdName
                                                    ) +
                                                    " " +
                                                    _vm._s(voucherMap.boIdPhone)
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("div", { staticClass: "gray9" }, [
                                          _vm._v(
                                            _vm._s(voucherMap.creationDate)
                                          )
                                        ]),
                                        voucherMap.voucherType == "SELLER" &&
                                        (_vm.detail.orderStatus == "1" ||
                                          _vm.detail.orderStatus == "2" ||
                                          _vm.detail.orderStatus == "3")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "mar10-l red",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.delSellerVoucherMap(
                                                      voucherMap
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    删除\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex mar10-t mar20-b mar19-l flex-wrap"
                                      },
                                      _vm._l(
                                        voucherMap.voucherPicList,
                                        function(vouche, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "wh64 radius4 mar5-r relative overflow"
                                            },
                                            [
                                              voucherMap.voucherType ==
                                                "SELLER" &&
                                              (_vm.detail.orderStatus == "1" ||
                                                _vm.detail.orderStatus == "2" ||
                                                _vm.detail.orderStatus == "3")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex radius100 del-voucher absolute justify-center items-center pointer del",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.delSellerVoucher(
                                                            vouche.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("./images/del.png")
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.isZip(vouche.url)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "64px",
                                                        display: "block",
                                                        "text-align": "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: vouche.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            attrs: {
                                                              src:
                                                                "https://files.nxin.com/mobile/public/zip.png"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm.isWord(vouche.url)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "64px",
                                                        display: "block",
                                                        "text-align": "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: vouche.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            attrs: {
                                                              src:
                                                                "https://files.nxin.com/mobile/public/word.png"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm.isPdf(vouche.url)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "64px",
                                                        display: "block",
                                                        "text-align": "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: vouche.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            attrs: {
                                                              src:
                                                                "https://files.nxin.com/mobile/public/pdf.png"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm.isExcel(vouche.url)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "64px",
                                                        display: "block",
                                                        "text-align": "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: vouche.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            attrs: {
                                                              src:
                                                                "https://files.nxin.com/mobile/public/excel.png"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _c("el-image", {
                                                    attrs: {
                                                      src:
                                                        vouche.url +
                                                        "?imageView2/1/w/80/h/80",
                                                      "preview-src-list": voucherMap.voucherPicList.map(
                                                        function(item) {
                                                          return item.url
                                                        }
                                                      ),
                                                      "initial-index": index
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm.detail.orderDtlBo.orderType == 4
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { "min-height": "600px" },
                          attrs: { label: "提货明细", name: "PickUpDetails" }
                        },
                        [
                          _vm.detail.pickupInfo
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "mar20-tb flex items-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pad15-lr flex radius4 pick-up-details-collect"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "预定数量：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo.ydQuantity
                                              )
                                          )
                                        ]),
                                        _c("div", { staticClass: "mar20-l" }, [
                                          _vm._v(
                                            "已提数量：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo.ytQuantity
                                              )
                                          )
                                        ]),
                                        _c("div", { staticClass: "mar20-l" }, [
                                          _vm._v(
                                            "执行中：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo
                                                  .zxzQuantity
                                              )
                                          )
                                        ]),
                                        _c("div", { staticClass: "mar20-l" }, [
                                          _vm._v(
                                            "余量：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo.ylQuantity
                                              )
                                          )
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pad15-lr mar30-l flex radius4 pick-up-details-collect"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "发货差额：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo.ceAmount
                                              ) +
                                              "元"
                                          )
                                        ]),
                                        _c("div", { staticClass: "mar20-l" }, [
                                          _vm._v(
                                            "质量扣补：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo.kbAmount
                                              ) +
                                              "元"
                                          )
                                        ]),
                                        _c("div", { staticClass: "mar20-l" }, [
                                          _vm._v(
                                            "合计：" +
                                              _vm._s(
                                                _vm.detail.pickupInfo.ceHjAmount
                                              ) +
                                              "元"
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.detail.pickupInfo.vehicleList
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "orderId",
                                        label: "提货单号",
                                        width: "160",
                                        fixed: ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "orderDate",
                                        label: "下单日期",
                                        width: "100"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "expectedPickupDate",
                                        label: "提货日期",
                                        width: "100"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "licensePlateNum",
                                        label: "车牌号",
                                        width: "100"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "提货数量" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      scope.row
                                                        .pickupQuantity || "-"
                                                    )
                                                ),
                                                scope.row.pickupQuantity
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .pickupGoodsUnit
                                                        )
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3614060059
                                      )
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "实提数量" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    class: {
                                                      green:
                                                        scope.row
                                                          .actualSendQuantity &&
                                                        scope.row
                                                          .actualSendQuantity !=
                                                          scope.row
                                                            .pickupQuantity
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          scope.row
                                                            .actualSendQuantity ||
                                                            "-"
                                                        )
                                                    ),
                                                    scope.row.actualSendQuantity
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .pickupGoodsUnit
                                                            )
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1953282531
                                      )
                                    }),
                                    _c("el-table-column", {
                                      attrs: { prop: "name", label: "司机" }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "tel",
                                        label: "联系方式",
                                        width: "114"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "idCard",
                                        label: "身份证",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "orderStatusCn",
                                        label: "状态"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "操作", width: "120" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/v/order/detailSeller/" +
                                                        scope.row.orderId,
                                                      type: "primary",
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._v("详情")]
                                                ),
                                                scope.row.orderStatus == "DONE"
                                                  ? _c(
                                                      "el-link",
                                                      {
                                                        staticClass: "mar15-l",
                                                        attrs: {
                                                          type: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.allowanceHandle(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" 质量扣补 ")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1015512491
                                      )
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _c("el-empty", {
                                attrs: { description: "暂无数据" }
                              })
                        ],
                        2
                      )
                    : [
                        _c(
                          "el-tab-pane",
                          {
                            staticStyle: { "min-height": "600px" },
                            attrs: { label: "发票信息", name: "order4" }
                          },
                          [
                            _c("div", { staticClass: "border pad20" }, [
                              _c(
                                "div",
                                { staticClass: "flex mar10-b flex-item1 fb" },
                                [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                发票种类：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .issueTypeCn != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .issueTypeCn
                                            : "纸质发票"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                发票类型：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .typeCn != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .typeCn
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                抬头类型：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .invoicetitleTypeCn != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .invoicetitleTypeCn
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex mar10-b flex-item1" },
                                [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                发票抬头：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .receipt != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .receipt
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                税号：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .taxRegistrationNumber != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .taxRegistrationNumber
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                单位地址：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .companyAddr != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .companyAddr
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex mar10-b flex-item1" },
                                [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                单位电话：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .companyTel != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .companyTel
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                开户银行：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .bankOfDeposit != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .bankOfDeposit
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                银行账号：" +
                                        _vm._s(
                                          _vm.detail.orderDtlBo.orderInvoice &&
                                            _vm.detail.orderDtlBo.orderInvoice
                                              .bankAccount != ""
                                            ? _vm.detail.orderDtlBo.orderInvoice
                                                .bankAccount
                                            : "无"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex mar10-b flex-item1" },
                                [
                                  _vm.detail.orderDtlBo.orderInvoice &&
                                  _vm.detail.orderDtlBo.orderInvoice.contractUrl
                                    ? _c("div", { staticClass: "item" }, [
                                        _vm._v(
                                          "\n                协议：\n                "
                                        ),
                                        _vm.detail.orderDtlBo.orderInvoice
                                          .invoiceContractType === "invoiceSl"
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "red",
                                                attrs: {
                                                  target: "_blank",
                                                  href:
                                                    _vm.detail.orderDtlBo
                                                      .orderInvoice.contractUrl
                                                }
                                              },
                                              [_vm._v("权利义务转让协议")]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                staticClass: "red",
                                                attrs: {
                                                  target: "_blank",
                                                  href:
                                                    _vm.detail.orderDtlBo
                                                      .orderInvoice.contractUrl
                                                }
                                              },
                                              [_vm._v("代付协议")]
                                            )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _c("div", { staticClass: "mar10-b" }, [
                                _vm._v("发票详情："),
                                _c("span", { staticClass: "gray6" }, [
                                  _vm._v("可上传发票图片或文件")
                                ])
                              ]),
                              _vm.detail.orderStatus == "4" ||
                              _vm.detail.orderStatus == "5"
                                ? _c("div", { staticClass: "mar10-b" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-wrap upload invoice-upload"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex relative pointer box"
                                          },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                attrs: {
                                                  limit:
                                                    2 -
                                                      _vm.detail.invoicePicList
                                                        .length ==
                                                    0
                                                      ? -1
                                                      : 2 -
                                                        _vm.detail
                                                          .invoicePicList
                                                          .length,
                                                  action:
                                                    _vm.env.VUE_APP_fileserver +
                                                    "persistentUpload",
                                                  "file-list":
                                                    _vm.invoiceFileList,
                                                  "list-type": "picture-card",
                                                  "on-success":
                                                    _vm.uploadInvoiceSuccess,
                                                  "before-upload":
                                                    _vm.uploadInvoiceBefore,
                                                  "on-remove":
                                                    _vm.uploadInvoiceRemove,
                                                  "on-exceed":
                                                    _vm.uploadInvoiceExceed
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./images/add.png")
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "mar30-l self-center",
                                            attrs: { type: "primary" },
                                            on: { click: _vm.submitInvoice }
                                          },
                                          [_vm._v("保存")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "flex" },
                                _vm._l(_vm.detail.invoicePicList, function(
                                  invoicePic,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "radius4 border flex justify-center items-center wh80 mar5-r relative"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "absolute pointer bg-white radius100 invoice-del",
                                        attrs: {
                                          src: require("./images/del.png")
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.delInvoicePic(
                                              invoicePic.id
                                            )
                                          }
                                        }
                                      }),
                                      invoicePic.suffix !== "pdf"
                                        ? _c("el-image", {
                                            attrs: {
                                              src:
                                                invoicePic.url +
                                                "?imageView2/1/w/70/h/70",
                                              "preview-src-list": _vm.detail.invoicePicList.map(
                                                function(item) {
                                                  return item.url
                                                }
                                              ),
                                              "initial-index": index
                                            }
                                          })
                                        : _vm._e(),
                                      invoicePic.suffix === "pdf"
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: invoicePic.url,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "https://filesouthcdn.nxin.com/nxsc_1691545813992021546671317164323.png?imageView2/1/w/70/h/70"
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            staticStyle: { "min-height": "600px" },
                            attrs: { label: "操作记录", name: "order5" }
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.detail.operationRecordList,
                                  "header-row-class-name": "gray3 tab-header",
                                  border: "",
                                  "cell-class-name": "cell-td"
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "operatorContent",
                                    label: "操作内容"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createTime",
                                    label: "操作时间"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "boIdName", label: "操作人" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.detail.purchaseOrderList &&
                        _vm.detail.purchaseOrderList.length > 0
                          ? _c(
                              "el-tab-pane",
                              {
                                staticStyle: { "min-height": "600px" },
                                attrs: { label: "采购订单", name: "order6" }
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.detail.purchaseOrderList,
                                      "header-row-class-name":
                                        "gray3 tab-header",
                                      border: "",
                                      "cell-class-name": "cell-td"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "fundShopName",
                                        label: "供应商"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "orderTime",
                                        label: "订单时间"
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "操作" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      color: "#2e86ff"
                                                    },
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handlePurchaseOrderClick(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("订单详情")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1398118406
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                ],
                2
              ),
              _c("div", { staticClass: "pad10" }),
              [
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "订单快照",
                      visible: _vm.editOrderSnapshotDialogVisible,
                      width: "800px"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.editOrderSnapshotDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("el-alert", {
                      staticClass: "mar20-b",
                      attrs: {
                        title:
                          "交易快照包含订单创建时的商品描述和下单信息，买卖双方和平台在发生交易争议时 该页面作为判定依据。",
                        type: "error",
                        effect: "dark",
                        closable: false
                      }
                    }),
                    _c("el-divider"),
                    _c(
                      "el-row",
                      _vm._l(_vm.orderGoodsList, function(orderGoods, index) {
                        return _c(
                          "el-col",
                          {
                            key: index,
                            staticClass: "mar10-b",
                            attrs: { span: 5, offset: 1 }
                          },
                          [
                            _c(
                              "el-card",
                              { attrs: { "body-style": { padding: "0px" } } },
                              [
                                _c("img", {
                                  staticClass: "image",
                                  attrs: {
                                    src:
                                      orderGoods.goodsPic +
                                      "?imageView2/1/w/156/h/156"
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticStyle: { padding: "14px" } },
                                  [
                                    _c("span", { staticClass: "mar10-r" }, [
                                      _vm._v(
                                        "¥ " + _vm._s(orderGoods.sellFactPrice)
                                      )
                                    ]),
                                    _c("span", [
                                      _vm._v(_vm._s(orderGoods.goodsSpec))
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _c("el-divider"),
                    _c(
                      "el-form",
                      {
                        staticClass: "mar20-b",
                        attrs: {
                          "label-suffix": "：",
                          "label-position": "left",
                          size: "medium"
                        }
                      },
                      [
                        _c("el-form-item", [
                          _c("div", { staticClass: "flex" }, [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar30-l" }, [
                                _vm._v("下单时间：")
                              ]),
                              _c("div", { staticClass: "w200" }, [
                                _vm._v(_vm._s(_vm.detail.orderTime))
                              ])
                            ]),
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar30-l" }, [
                                _vm._v("支付类型：")
                              ]),
                              _c("div", [
                                _vm._v(_vm._s(_vm.detail.paymentTypeCn))
                              ])
                            ])
                          ])
                        ]),
                        _c("el-form-item", [
                          _c("div", { staticClass: "flex" }, [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar30-l" }, [
                                _vm._v("订单金额：")
                              ]),
                              _c("div", { staticClass: "w200" }, [
                                _vm._v(
                                  "\n                  ¥ " +
                                    _vm._s(
                                      _vm.detail.fmoney
                                        ? parseFloat(
                                            _vm.detail.fmoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    ) +
                                    "\n                  （含运费\n                  " +
                                    _vm._s(
                                      _vm.detail.freightMoney
                                        ? parseFloat(
                                            _vm.detail.freightMoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    ) +
                                    "\n                  ）\n                "
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar30-l" }, [
                                _vm._v("实付金额：")
                              ]),
                              _c("div", [
                                _vm._v("¥" + _vm._s(_vm.detail.pmoney))
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "medium" },
                            on: {
                              click: function($event) {
                                _vm.editOrderSnapshotDialogVisible = false
                              }
                            }
                          },
                          [_vm._v("关 闭")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "手机扫码上传",
                      visible: _vm.signatureDialogVisible,
                      width: "224px"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.signatureDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("canvas", {
                      ref: "qrCodeCanvas",
                      attrs: { width: "250", height: "250" }
                    }),
                    _c("div", { staticClass: "text-center" }, [
                      _vm._v("支持微信和智农通")
                    ])
                  ]
                ),
                _c("order_seller", {
                  ref: "order_seller_dialog",
                  attrs: {
                    order: _vm.detail,
                    orderGoodsList: _vm.orderGoodsList
                  },
                  on: { loadOrder: _vm.loadOrder }
                }),
                _c("contract_sign", {
                  ref: "contract_sign_dialog",
                  attrs: { order: _vm.detail },
                  on: { loadOrder: _vm.loadOrder }
                }),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: _vm.dialogFormVisiblePickupTime,
                      title:
                        _vm.showConfirmPickupType == "1"
                          ? "确认预计发货时间"
                          : "确认提货时间",
                      width: "500px"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogFormVisiblePickupTime = $event
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c(
                                "span",
                                { staticClass: "dialog-footer" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "text-center",
                                      on: {
                                        click: function($event) {
                                          _vm.dialogFormVisiblePickupTime = false
                                        }
                                      }
                                    },
                                    [_vm._v("取 消")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "text-center",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.savePickupTime }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.pickupTimeBtn) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1604000532
                    )
                  },
                  [
                    _vm.showConfirmPickupType == "1"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "mar10-b flex items-center" },
                            [
                              _c("div", { staticClass: "mar10-r" }, [
                                _vm._v("预计发货时间：")
                              ]),
                              _c("el-date-picker", {
                                attrs: {
                                  align: "right",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  size: "medium",
                                  placeholder:
                                    "选择" +
                                    (_vm.showConfirmPickupType == "1"
                                      ? "发货"
                                      : "提货") +
                                    "时间",
                                  "picker-options": _vm.pickerOptions
                                },
                                model: {
                                  value: _vm.selectPickupTime,
                                  callback: function($$v) {
                                    _vm.selectPickupTime = $$v
                                  },
                                  expression: "selectPickupTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "red" }, [
                            _vm._v("确认后将展示在订单详情，客户可见")
                          ])
                        ])
                      : _c("div", [
                          _c(
                            "div",
                            { staticClass: "mar20-b flex items-center" },
                            [
                              _c("div", { staticClass: "mar10-r" }, [
                                _vm._v("提货时间：")
                              ]),
                              _c("el-date-picker", {
                                staticClass: "mar5-r",
                                staticStyle: { width: "325px" },
                                attrs: {
                                  align: "right",
                                  type: "date",
                                  placeholder: "选择自提时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  size: "medium",
                                  "picker-options": _vm.pickerOptions
                                },
                                model: {
                                  value: _vm.selectPickupTime,
                                  callback: function($$v) {
                                    _vm.selectPickupTime = $$v
                                  },
                                  expression: "selectPickupTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex items-center" },
                            [
                              _c("div", { staticClass: "mar10-r" }, [
                                _vm._v("提货仓库：")
                              ]),
                              _c("el-input", {
                                staticStyle: { width: "325px" },
                                attrs: {
                                  size: "medium",
                                  placeholder: "详细提货地址（非必填）"
                                },
                                model: {
                                  value: _vm.sellerConfirmPickupWarehouse,
                                  callback: function($$v) {
                                    _vm.sellerConfirmPickupWarehouse = $$v
                                  },
                                  expression: "sellerConfirmPickupWarehouse"
                                }
                              })
                            ],
                            1
                          )
                        ])
                  ]
                )
              ]
            ],
            2
          )
        : _c("div", { staticStyle: { "min-height": "900px" } }),
      _c("ShippingOptions", { ref: "shippingOptionsRef" }),
      _c("contractPreview", {
        attrs: {
          url: _vm.contractPreviewUrl,
          visible: _vm.contractPreviewVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.contractPreviewVisible = $event
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "质量扣补",
            visible: _vm.allowanceVisible,
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.allowanceVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "red allowance-tips mar20-b" }, [
            _vm._v("质量扣补金额，将返还到客户预付款，请谨慎操作！！！")
          ]),
          _c(
            "el-form",
            {
              ref: "allowanceFormRef",
              staticClass: "allowance-form",
              attrs: {
                model: _vm.allowanceForm,
                "label-width": "100px",
                "label-suffix": "：",
                rules: _vm.allowanceFormRules
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "质量扣补", prop: "kbAmount" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入",
                      min: 0,
                      precision: 2
                    },
                    model: {
                      value: _vm.allowanceForm.kbAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.allowanceForm, "kbAmount", $$v)
                      },
                      expression: "allowanceForm.kbAmount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "kbRemark" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入",
                      type: "textarea",
                      maxlength: "100",
                      "show-word-limit": "",
                      rows: 3
                    },
                    model: {
                      value: _vm.allowanceForm.kbRemark,
                      callback: function($$v) {
                        _vm.$set(_vm.allowanceForm, "kbRemark", $$v)
                      },
                      expression: "allowanceForm.kbRemark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.allowanceVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "mar20-l",
                  attrs: { type: "primary" },
                  on: { click: _vm.allowanceSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }